import { Button } from 'app/components/ui/Button'
import { Text } from 'app/components/ui/Text'
import React from 'react'

import { UploadBlock, DescText } from './styled'
import { UploadBlockProps } from './types'

export const UploadBlockComponent = ({
  setIsUploadModalOpen,
}: UploadBlockProps): JSX.Element => {
  return (
    <UploadBlock>
      <Text variant='s24' weight='bold'>
        GIUSTIFICATIVI
      </Text>
      <DescText variant='s16'>
        Qui potete inserire i giustificativi dell’avvenuta veicolazione ed
        esposizione del marchio secondo gli accordi di visibilità concordata
        (foto, video, screenshot, reportistica varia).
        <br /> E’ consentito l’upload di file in vari formati, tra cui immagini,
        video, PDF, documenti Word e fogli di calcolo Excel. Non sono ammessi
        file compressi.
        <br />
        La dimensione massima consentita per ciascun file è di 50 MB.
      </DescText>
      <Button
        variant='black'
        size='normal'
        onClick={() => setIsUploadModalOpen(true)}
      >
        Carica Giustificativi
      </Button>
    </UploadBlock>
  )
}
